import React, { useRef, useEffect, useState } from "react";
import { Container, Button } from "react-bootstrap";
import "../styles/TestimonialsSection.scss";
import Logo from "../assets/logo.png";
import review1 from "../assets/reviews/0 (1).jpeg";
import review2 from "../assets/reviews/0 (2).jpeg";
import review3 from "../assets/reviews/0 (3).jpeg";
import review4 from "../assets/reviews/0 (4).jpeg";
import review5 from "../assets/reviews/0 (5).jpeg";
import review6 from "../assets/reviews/0 (6).jpeg";
import review7 from "../assets/reviews/0 (7).jpeg";
import review8 from "../assets/reviews/0 (8).jpeg";
import review9 from "../assets/reviews/0 (9).jpeg";
import review10 from "../assets/reviews/0 (10).jpeg";
import review11 from "../assets/reviews/0 (11).jpeg";
import review12 from "../assets/reviews/0 (12).jpeg";
import review13 from "../assets/reviews/0 (13).jpeg";
import review14 from "../assets/reviews/0 (14).jpeg";
import review15 from "../assets/reviews/0 (15).jpeg";
import review16 from "../assets/reviews/0 (16).jpeg";
import review17 from "../assets/reviews/0 (17).jpeg";
import review18 from "../assets/reviews/0 (18).jpeg";
import review19 from "../assets/reviews/0 (19).jpeg";
import review20 from "../assets/reviews/0 (20).jpeg";
import review21 from "../assets/reviews/0 (21).jpeg";

function ImageCarousel({
  images = [
    review1,
    review2,
    review3,
    review4,
    review5,
    review6,
    review7,
    review8,
    review9,
    review10,
    review11,
    review12,
    review13,
    review14,
    review15,
    review16,
    review17,
    review18,
    review19,
    review20,
    review21,
  ],
  interval = 5000, // ms between auto‑slides
}) {
  const carouselRef = useRef();
  const [animate, setAnimate] = useState(false);
  const [current, setCurrent] = useState(0);

  // 1) trigger animation on scroll into view
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimate(true);
          obs.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (carouselRef.current) obs.observe(carouselRef.current);
    return () => obs.disconnect();
  }, []);

  // 2) auto‑slide
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % images.length);
    }, interval);
    return () => clearInterval(timer);
  }, [images.length, interval]);

  const prev = () => setCurrent((c) => (c - 1 + images.length) % images.length);
  const next = () => setCurrent((c) => (c + 1) % images.length);

  return (
    <div className="image-carousel" ref={carouselRef}>
      <div
        className="track"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {images.map((src, i) => (
          <div
            key={i}
            className={`slide ${animate ? "visible" : ""}`}
            style={{ "--i": i }}
          >
            <img src={src} alt={`slide-${i}`} />
          </div>
        ))}
      </div>
      <button className="nav prev" onClick={prev}>
        &larr;
      </button>
      <button className="nav next" onClick={next}>
        &rarr;
      </button>
    </div>
  );
}

export default function TestimonialsSection() {
  return (
    <section className="testimonials-section py-5">
      <Container>
        <div className="section-header text-center mb-4">
          <img src={Logo} alt="ThermalHydro" />
          <h2>O que falam sobre nós</h2>
        </div>
        <ImageCarousel />
      </Container>
    </section>
  );
}
